
import { defineComponent } from 'vue'
import { IBusinessModel, IFederatedDataset } from '../../../Workspace'
import { FilterOperator } from 'primevue/api'
import { filterDefault } from '@/helpers/commons/filterHelper'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Menu from 'primevue/menu'
import workspaceModelsTableDescriptor from './WorkspaceModelsTableDescriptor.json'

export default defineComponent({
    name: 'workspace-models-table',
    components: { Column, DataTable, Menu },
    props: { propItems: { type: Array } },
    emits: ['openDatasetInQBEClick', 'editDatasetClick', 'deleteDatasetClick', 'selected'],
    data() {
        return {
            workspaceModelsTableDescriptor,
            items: [] as IBusinessModel[] | IFederatedDataset[],
            columns: [] as any[],
            filters: {
                name: {
                    operator: FilterOperator.AND,
                    constraints: [filterDefault]
                },
                description: {
                    operator: FilterOperator.AND,
                    constraints: [filterDefault]
                }
            } as any,
            menuItems: [] as any[],
            user: null as any
        }
    },
    watch: {
        propItems() {
            this.loadTable()
        }
    },
    created() {
        this.user = (this.$store.state as any).user
        this.loadTable()
    },
    methods: {
        loadTable() {
            this.loadItems()
        },
        loadItems() {
            this.items = this.propItems as IBusinessModel[] | IFederatedDataset[]
        },
        canDeleteFederation(federation: IFederatedDataset) {
            return this.user.isSuperadmin || this.user.userId === federation.owner
        },
        openDatasetInQBE(dataset: IBusinessModel | IFederatedDataset) {
            this.$emit('openDatasetInQBEClick', dataset)
        },
        editDataset(dataset: IBusinessModel | IFederatedDataset) {
            this.$emit('editDatasetClick', dataset)
        },
        deleteDataset(dataset: IBusinessModel | IFederatedDataset) {
            this.$emit('deleteDatasetClick', dataset)
        },
        toggle(event: any, dataset: IFederatedDataset) {
            this.createMenuItems(dataset)
            const menu = this.$refs.menu as any
            menu.toggle(event)
        },
        createMenuItems(dataset: IFederatedDataset) {
            this.menuItems = []
            this.menuItems.push({ icon: 'pi pi-pencil', label: this.$t('workspace.myModels.editDataset'), command: () => this.editDataset(dataset) })
            if (this.canDeleteFederation(dataset)) {
                this.menuItems.push({ icon: 'fas fa-trash-alt', label: this.$t('workspace.myModels.deleteDataset'), command: () => this.deleteDataset(dataset) })
            }
        }
    }
})
